import { http } from "../../../shared/api/http";
// import { Order } from "../models/types";

export async function updateOrderStatus(orderId:any,data:any): Promise<any> {
  const res = await http.put(`waiter/orders/${orderId}/status`,data);
  return res.data[0];
}